module.exports = __webpack_public_path__ + "img/2024-03-08a_2.8fef974c.jpg";